export default function AddCardButton({ disabled, onClick }) {
  return (
    <button type="button" className="btn btn-outline-primary bg-white" disabled={disabled} onClick={onClick}>
      Add another card
    </button>
  );
}
